import React, { Component } from 'react';
import moment from 'moment-timezone';
import { Select } from 'antd';
import { map, message } from 'lodash';


import NewTicket from './NewTicket';
import TicketReply from './TicketReply';
import Loader from '../../../../../Common/Component/Loader';
import EmptyData from "../../../../../Common/Component/EmptyData";

const { Option } = Select;


class Tickets extends Component {

  state = {
    messageData: [],
    AllUser: [],
    GroupList: [],
    ticket_details: {},
    message_list_filter: {
      user__serviceorder__field_office__uuid: '',
      reason: '',
      assigned_user__uuid: '',
      status: '',
      priority: '',
      ordering: ''
    },
    is_new_ticket: false,
    is_read_ticket: false,
    loader: false
  }

  componentDidMount = () => {
    this.setState({
      loader: true
    })
    //Get User message and tickets
    this.props.getAllMessages({ 'user__uuid': this.props.customerId })
    //Get all user list
    this.props.getUserList({ 'limit': 1000, 'offset': 0, 'ordering': 'first_name', 'is_case_mgmt': true})

    //get Group 
    this.props.getGroupList({ 'limit': 15, offset: 0 })

    let is_ticket_details = JSON.parse(localStorage.getItem('is_ticket_details')) || null;
    if (is_ticket_details) {
      this.setState({
        ticket_details: is_ticket_details.record,
        is_read_ticket: true
      })
      localStorage.removeItem('is_ticket_details');
    }


  }


  UNSAFE_componentWillReceiveProps = (props) => {

    //get Message
    if (Object.keys(props.AllMessages.data).length > 0 && props.AllMessages.data !== this.props.AllMessages.data) {
      this.setState({
        messageData: props.AllMessages.data.results,
        loader: false
      })
    }

    if (Object.keys(props.AllMessages.errors).length > 0 && props.AllMessages.errors !== this.props.AllMessages.errors) {
      message.error('Something went wrong', 10);
      this.setState({
        loader: false,
      })
    }

    //get User
    if (Object.keys(props.UserList.data).length > 0 && props.UserList.data !== this.props.UserList.data) {
      this.setState({
        AllUser: props.UserList.data.results,
        loader: false
      })
    }

    if (Object.keys(props.UserList.errors).length > 0 && props.UserList.errors !== this.props.UserList.errors) {
      message.error('Something went wrong', 10);
      this.setState({
        loader: false,
      })
    }
    //Get Group list
    if (Object.keys(props.GroupList.data).length > 0 && props.GroupList.data !== this.props.GroupList.data) {
      this.setState({
        loader: false,
        GroupList: props.GroupList.data.results
      })
    }

    if (Object.keys(props.GroupList.errors).length > 0 && props.GroupList.errors !== this.props.GroupList.errors) {
      message.error('Something went wrong', 10);
      this.setState({
        loader: false,
      })
    }


  }

  // calulate Date 
  calulateDate = (created_timestamp) => {
    let currentDate = moment();

    if (moment(created_timestamp).isSame(currentDate, "day")) {
      return moment(created_timestamp).fromNow();

    } else if (
      moment(created_timestamp).isSame(
        moment()
          .subtract(1, "days")
          .startOf("day"),
        "d"
      )
    ) {
      return "Yesterday";
    } else {
      return moment(created_timestamp).format("MM-DD-YYYY");
    }
  }

  // Render All Ticket
  renderAllTicket = () => {
    let { messageData } = this.state;
    return map(messageData, (item, i) => {
      return (
        <div
          onClick={() => {
            this.setState({ is_read_ticket: true, ticket_details: messageData[i] });
            this.props.readTickets({ 'uuid': messageData[i].uuid, 'read_by_staff_user': true })
          }}
          className={item.read_by_staff_user === false ? 'trow open_ticket' : 'trow close_ticket'}
          key={i}>
          <span className="title" >{item.title}</span>
          {item.priority ?
            <span
              className={
                item.priority === "4" ? 'status priority_medium'
                  :
                  item.priority === "3" ? 'status priority_high' : ''
              }

            >
              { item.priority === "4" ? <span className="status_before medium" style={{fontWeight: "normal"}}>Standard Priority</span>
                : item.priority === "3" ? <span className="status_before high" style={{fontWeight: "normal"}}>High Priority </span> : ''
              } </span> : <span className="status low">No Priority </span>}
          <span className='assigned_user ellipse'><i className="las la-user"/> {item.assigned_user_details ? `${item.assigned_user_details.first_name} ${item.assigned_user_details.last_name}` : 'Not Assigned'}</span>
          {item.status ? <span className={item.status === "open" ? 'status status_open' : 'status status_closed'}>{item.status}  </span> : ''}
          <span className="time">Created {this.calulateDate(item.created_at)}</span>
        </div>
      )

    })

  }

  //Message listing filter
  filterOnChange = (e, type) => {
    let { message_list_filter } = this.state;
    message_list_filter = Object.assign(message_list_filter, { [type]: e });
    this.setState({
      message_list_filter,
      loader: true
    });
    let data = {
      user__uuid: this.props.customerId,
      ...message_list_filter,
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getAllMessages(data)
  }


  //Hide Create new ticket
  closeCreteTicket = (is_new_ticket) => {
    this.setState({
      is_new_ticket
    })

  }

  //Hide Replies ticket
  closeReplieTicket = (is_read_ticket) => {
    this.setState({
      is_read_ticket
    });

  }

  render() {
    let { message_list_filter, AllUser, loader, is_new_ticket, is_read_ticket } = this.state;
    const noData = this.state.messageData?.length <= 0

    return (
      <React.Fragment >
        <div className="block-row p-0">
          {is_new_ticket || is_read_ticket ?
            <div className="back_link flex">
              <span onClick={() => {
                if (is_new_ticket) {
                  this.closeCreteTicket(false);
                }
                if (is_read_ticket) {
                  this.closeReplieTicket(false)
                }
                this.props.getAllMessages({ 'user__uuid': this.props.customerId })

              }}> Back to all tickets</span>
              {is_read_ticket ? <button
                className="btn btn-warning mr-30"
                onClick={() => {
                  this.setState({
                    is_read_ticket: false,
                    is_new_ticket: true,
                    message_list_filter: {
                      user__serviceorder__field_office__uuid: '',
                      reason: '',
                      assigned_user__uuid: '',
                      status: '',
                      priority: '',
                      ordering: ''
                    }
                  })
                }}
              >
                Add New Ticket
              </button> : ''}
            </div>
            : ''}
          {!is_new_ticket && !is_read_ticket ?
            <div className="block-row pb-0">
              <div className="filter_wrapper p-0" style={{ 'background': '#F4F7F9' }}>
                <div className='left_side form-group'>
                  <div className="fitem">
                    <Select
                      defaultValue=""
                      className="filter_ant_select filter_by_sort swhite"
                      disabled={noData}
                      onChange={(e) => { this.filterOnChange(e, 'ordering') }}
                      value={message_list_filter.ordering}
                      virtual={false}
                    >
                      <Option value="">All</Option>
                      <Option value="created_at"><i className="las la-long-arrow-alt-up sort_by_icon"></i>Created at</Option>
                      <Option value="-created_at"><i className="las la-long-arrow-alt-down sort_by_icon"></i>Created at</Option>
                    </Select>
                  </div>
                  <div className="fitem">
                    <Select
                      className="filter_ant_select filter_by_assign swhite"
                      virtual={false}
                      showSearch
                      disabled={noData}
                      showArrow={true}
                      filterOption={false}
                      notFoundContent={null}
                      onSearch={(e) => { this.props.getUserList({ 'search': e, 'limit': 1000, 'offset': 0, 'ordering': 'first_name', 'is_case_mgmt': true}) }}
                      onSelect={() => { this.props.getUserList({ 'limit': 1000, 'offset': 0, 'ordering': 'first_name', 'is_case_mgmt': true}) }}
                      onSelect={() => { this.props.getUserList({ offset: 0, limit: 10 }); }}
                      value={message_list_filter.assigned_user__uuid}
                    >
                      <Option value="">All</Option>
                      {
                        map(AllUser, (item) => {
                          if (item.first_name && item.last_name) {
                            return (<Option value={item.uuid} key={item.uuid}>{item.first_name} {item.last_name}</Option>)
                          }

                        })
                      }

                    </Select>
                  </div>
                  <div className="fitem">
                    <Select
                      className="filter_ant_select filter_by_status swhite"
                      virtual={false}
                      onChange={(e) => { this.filterOnChange(e, 'status') }}
                      value={message_list_filter.status}
                      disabled={noData}
                    >
                      <Option value="">All</Option>
                      <Option key='open' value="open"><span className="open prty">Open</span></Option>
                      <Option key='closed' value="closed"><span className="closed prty">Closed</span></Option>
                    </Select>
                  </div>
                  <div className="fitem">
                    <Select
                      className="filter_ant_select filter_by_Priority  swhite"
                      virtual={false}
                      onChange={(e) => { this.filterOnChange(e, 'priority') }}
                      value={message_list_filter.priority}
                      dropdownClassName="sm-filter"
                      disabled={noData}
                    >
                      <Option value="">All</Option>
                      <Option key="4" value="4"><span className="medium prty">Standard Priority</span></Option>
                      <Option key="3" value="3"><span className="high prty">High Priority</span></Option>
                    </Select>
                  </div>
                </div>
                <div className="right_side">
                  {this.state.messageData?.length > 0 ? <div>
                    <span className="ico-btn"
                      onClick={() => {
                        this.props.getCSVData({ 'format': 'csv', 'user__uuid': this.props.customerId });
                      }}
                    >
                      <i className="las la-file-csv"></i>
                    </span>

                  </div> : ''}
                  <div>
                    <button
                      className="btn btn-warning"
                      onClick={() => {
                        this.setState({
                          is_new_ticket: true,
                          message_list_filter: {
                            user__serviceorder__field_office__uuid: '',
                            reason: '',
                            assigned_user__uuid: '',
                            status: '',
                            priority: '',
                            ordering: ''
                          }
                        })
                      }}
                    >
                      Add New Ticket
                    </button>
                  </div>
                </div>
              </div>
            </div>
            : ''}
          {!is_new_ticket && !is_read_ticket ?
            <div className="display_my_tickets block-row">
              <div className="message_list">
                <div className="msg-tbl-block">
                  {this.state.messageData?.length > 0 ? this.renderAllTicket() : <EmptyData style={{ padding: "20px" }} />}
                </div>
              </div>
            </div>
            : ''}
          {/* New Tickets */}
          {is_new_ticket ?
            <NewTicket
              AllUser={this.props.AllUser}
              GroupList={this.props.GroupList}
              getUserList={this.props.getUserList}
              getGroupList={this.props.getGroupList}
              customerId={this.props.customerId}
              createNewTickets={this.props.createNewTickets}
              getAllMessages={this.props.getAllMessages}
              NewTicket={this.props.NewTicket}
              closeCreteTicket={this.closeCreteTicket}
              CommercialCustomer={this.props.CommercialCustomer}
              {...this.props}
            /> : ''}
          {is_read_ticket ?
            <TicketReply
              AllUser={this.props.AllUser}
              GroupList={this.props.GroupList}
              getUserList={this.props.getUserList}
              getGroupList={this.props.getGroupList}
              customerId={this.props.customerId}
              messageReplay={this.props.messageReplay}
              ticket_details={this.state.ticket_details}
              MessageReplies={this.props.MessageReplies}
              RepliesonTicket={this.props.RepliesonTicket}
              UpdateTickets={this.props.UpdateTickets}
              UpdateMesssage={this.props.UpdateMesssage}
              closeReplieTicket={this.closeReplieTicket}
              getAllMessages={this.props.getAllMessages}
            
              {...this.props}
            />
            : ''}
          {
            loader && <Loader />
          }
        </div>
      </React.Fragment>
    );
  }
}

export default Tickets;